import { Link } from "react-router-dom";
import { marketingUrl } from "../../lib/marketingUrls";
import { brand, brandLogos, contactEmail, contactMailto } from "../../brand";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer>
      <div className="footer-cols-wrapper">
        <div className="col-1">
          <div className="col-inner-wrapper">
            <a href={marketingUrl("/")}>
              <img src={brandLogos.white} alt={brand.displayName} className="logo-footer" />
            </a>
            <p dangerouslySetInnerHTML={{ __html: brand.footerDescriptionHtml }} />
          </div>
        </div>

        <div className="col-2">
          <div className="col-inner-wrapper">
            <h4>Account</h4>
            <ul>
              <li>
                <Link to={"/sign-up"}>Sign Up</Link>
              </li>
              <li>
                <Link to={"/login"}>Login</Link>
              </li>
              <li>
                <a href={contactMailto}>Contact Us</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="col-3">
          <div className="col-inner-wrapper">
            <h4>Contact Us</h4>
            <ul>
              <li>
                <a href={contactMailto}>{contactEmail}</a>
              </li>
              <li>
              <a onClick={() => {
                  window.scrollTo(0, 0)
                }} id="backToTop">Scroll to top ^</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom-part">
        <p>Copyright © {new Date().getFullYear()} {brand.displayName}. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
